<template>
  <e-btn variant="link" class="mt-6 mb-4" @click="logout"> Выйти из учетной записи</e-btn>
</template>

<script setup lang="ts">
import { EBtn } from '@/core/components/ui';
import { useServices } from '@/core/composables/services';

const { $auth } = useServices();

const logout = () => {
  $auth.logout();
};
</script>

<style scoped lang="scss"></style>
